import { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import CustomLoader from "../../components/CustomeLoader";
import socialicon3 from "../../ulits/images/social-icon3.svg";
import shareicon from "../../ulits/images/share-icon.svg";
import usericon from "../../ulits/images/user_icon.svg";
import warrantyicon from "../../ulits/images/warranty_icon.svg";
import serviceicon from "../../ulits/images/service_icon.svg";
import { Modal } from "react-bootstrap";
import driveicon from "../../ulits/images/drive_icon.svg";
import { configs } from "../../config";
import Accordion from "react-bootstrap/Accordion";
import monthicon from "../../ulits/images/month_icon.svg";
import searchicon from "../../ulits/images/search_icon.svg";
import checkedicon from "../../ulits/images/checked_icon.svg";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { Navigation, Thumbs } from "swiper/modules";
import { useDispatch, useSelector } from "react-redux";
import { homeAction } from "../../_actions/home.action";
import parse from "html-react-parser";
import { status } from "../../_constants/commonLhd";
import { Helmet } from "react-helmet";
import Printicon from "../../ulits/images/Print_icon.svg";
import caricon from "../../ulits/images/car_icon.svg";
import partExchnage from "../../ulits/images/partExchange.svg";

const Print = () => {
  const [loader, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);
  const location = useLocation();
  const [cars, setCars] = useState(location.state || null);
  const [active, setActive] = useState("button1");
  const navigate = useNavigate();
  const [isValidate2, setIsValidate2] = useState(false);
  const [isValidate, setIsValidate] = useState(false);
  const { slug } = useParams();

  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const mainSwiperRef = useRef(null);
  const [activeButtonIndex, setActiveButtonIndex] = useState(0);
  const [printTrigger, setPrintTrigger] = useState(false);
  const [error2, setError2] = useState({});

  const handlePrint = () => {
    setPrintTrigger(true);
  };

  useEffect(() => {
    if (printTrigger) {
      window.print();
      setPrintTrigger(false);
    }
  }, [printTrigger]);

  // const [credentials, setCredentials] = useState({
  //   name: "",
  //   email: "",
  //   phone: "",
  //   bestTime: "",
  // });

  const [credentials2, setCredentials2] = useState({
    name: "",
    email: "",
    phone: "",
    // message: "",
  });
  const dispatch = useDispatch();

  const homeData = useSelector((state) => state.home);

  useEffect(() => {
    if (cars) {
      dispatch(homeAction.getCarDetail({ slug }));
    } else {
      setLoading(false);
    }
  }, [dispatch, slug]);

  useEffect(() => {
    if (homeData && homeData.car_details_status === status.SUCCESS) {
      setCars(homeData.car_details_data);
      setLoading(false);
    }
  }, [homeData]);

  const handleChange2 = (e) => {
    const { name, value } = e.target;
    if (name === "phone" && value.length > 12) {
      return;
    }
    setCredentials2((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => {
      setLoading(false);
    }, 1500);
  }, []);

  const handleModal2Close = () => {
    setModal2(false);
  };
  const handleModal2Open = () => {
    setModal2(true);
  };

  const validateCredentials2 = (data) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const PhoneRegex = /^\d{10,12}$/;
    const errors = {
      name: { message: "" },
      email: { message: "" },
      phone: { message: "" },
      message: { message: "" },
      isValid: true,
    };

    if (!data.name || data.name.length <= 2) {
      errors.name.message = "Name must be at least 3 characters";
      errors.isValid = false;
    }

    if (!data.email || !emailRegex.test(data.email)) {
      errors.email.message = "Enter valid email";
      errors.isValid = false;
    }

    if (!data.phone || !PhoneRegex.test(data.phone)) {
      errors.phone.message = "Enter a valid phone number";
      errors.isValid = false;
    }

    // if (!data.message || data.message.trim() === "") {
    //   errors.message.message = "Message is required";
    //   errors.isValid = false;
    // }

    return errors;
  };

  const handleSubmit2 = (e) => {
    e.preventDefault();

    const errors = validateCredentials2(credentials2);
    setError2(errors);

    if (errors.isValid) {
      dispatch(homeAction.carInquiry(credentials2));
      handleModal2Close();
      setCredentials2({
        name: "",
        email: "",
        phone: "",
        // message: "",
      });
      setError2({});
    }
  };

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          image: window.location.href,
          title: "Check this out!",
          text: "Visit this amazing website!",
          url: window.location.href,
        });
      } catch (error) {
        console.error("Error sharing:", error);
      }
    } else {
      alert("Sharing is not supported on this device.");
    }
  };

  return (
    <div className="main-wrapper print-area" id="main-print">
      <div className="car-listing-section car-details">
        <div className="container">
          <div className="modern-filter-listing">
            <div className="car-listing-right">
              <div className="car-listing-right-top-left-text">
                <h1>{cars && cars.details}</h1>
              </div>
              <div className="car-list-btn">
                <button
                  className={`primary-btn sm ${activeButtonIndex === 0 ? "active" : ""
                    }`}
                  onClick={() => {
                    setActiveButtonIndex(0);
                    handleModal2Open();
                  }}
                >
                  <div className="car_icon" />
                  <span>VEHICLE ENQUIRY</span>
                </button>
                <button
                  className={`primary-btn sm ${activeButtonIndex === 1 ? "active" : ""
                    }`}
                  onClick={() => {
                    setActiveButtonIndex(1);
                  }}
                >
                  <img src={partExchnage} alt="" />
                  <span>PART EXCHANGE</span>
                </button>

                <button
                  className={`primary-btn sm ${activeButtonIndex === 2 ? "active" : ""
                    }`}
                  onClick={() => {
                    setActiveButtonIndex(2);
                    handleShare();
                  }}
                >
                  <img src={shareicon} alt="" />
                  <Link style={{ textDecoration: "none" }}>
                    <span> SHARE THIS</span>
                  </Link>
                  {/* SHARE THIS */}
                </button>
                <div className="print">
                  <button
                    className={`primary-btn sm ${activeButtonIndex === 3 ? "active" : ""
                      }`}
                    onClick={() => {
                      setActiveButtonIndex(3);
                      handlePrint();
                    }}
                  >
                    <img src={Printicon} alt="" />
                    <span>Print</span>
                  </button>
                </div>
              </div>
              <div className="car-list-img"></div>

              <div>
                <Swiper
                  onSwiper={(swiper) => (mainSwiperRef.current = swiper)}
                  thumbs={{
                    swiper:
                      thumbsSwiper && !thumbsSwiper.destroyed
                        ? thumbsSwiper
                        : null,
                  }}
                  modules={[Navigation, Thumbs]}
                  spaceBetween={0}
                  className="image-container first-slider"
                >
                  {cars?.image?.map((img, index) => (
                    <SwiperSlide key={index}>
                      <img
                        src={`${configs.localApiUrl}${img}`}
                        alt={`slide-${index}`}
                        style={{
                          width: "100%",
                          // height: "400px",
                          objectFit: "cover",
                        }}
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
                <div className="swiper-container">
                  <div className="swiper-button-prev custom-prev"></div>
                  <div className="swiper-button-next custom-next"></div>
                  <Swiper
                    onSwiper={(swiper) => {
                      setThumbsSwiper(swiper);
                      swiper.on("slideChange", () => {
                        if (
                          mainSwiperRef.current &&
                          !mainSwiperRef.current.destroyed
                        ) {
                          mainSwiperRef.current.slideTo(swiper.activeIndex);
                        }
                      });
                    }}
                    watchSlidesProgress
                    slidesPerView={4}
                    spaceBetween={10}
                    navigation={{
                      nextEl: ".custom-next",
                      prevEl: ".custom-prev",
                    }}
                    modules={[Navigation, Thumbs]}
                    className="image-container"
                    style={{ marginTop: "20px" }}
                    breakpoints={{
                      320: {
                        slidesPerView: 3,
                        spaceBetween: 15,
                      },
                      480: {
                        slidesPerView: 3,
                        spaceBetween: 15,
                      },
                      640: {
                        slidesPerView: 4,
                        spaceBetween: 20,
                      },
                      768: {
                        slidesPerView: 4,
                        spaceBetween: 20,
                      },
                      1024: {
                        slidesPerView: 4,
                        spaceBetween: 20,
                      },
                    }}
                  >
                    {cars?.image?.map((img, index) => (
                      <SwiperSlide key={index}>
                        <img
                          crossOrigin="anonymous"
                          src={`${configs.localApiUrl}${img}`}
                          alt={`slide-${index}`}
                          style={{
                            width: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </div>

              <div className="car-listing-right-bottom">
                <div className="stm-accordion-single-unit right-hand-drive">
                  <Accordion >
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>DESCRIPTION</Accordion.Header>
                      <Accordion.Body>
                        {/* {parse(cars && cars.description)} */}
                        {cars && cars.description ? (
                          parse(cars.description)
                        ) : (
                          <p>No description available</p>
                        )}
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                      <Accordion.Header>
                        ADDITIONAL INFORMATION
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="information">
                          <div className="addi-information">
                            <div className="box">
                              <div className="information-text">
                                <img src={usericon} alt="" />
                                <p style={{ flex: "3" }}>
                                  {cars && cars.carOwner
                                    ? `${cars.carOwner} ${parseInt(cars.carOwner) === 1
                                      ? "Owner"
                                      : "Owners"
                                    }`
                                    : ""}
                                </p>
                              </div>
                            </div>
                            <div className="box">
                              <div className="information-text">
                                <img src={monthicon} alt="" />
                                <p>{cars && cars.carMot}</p>
                              </div>
                            </div>
                            <div className="box">
                              <div className="information-text">
                                <img src={warrantyicon} alt="" />
                                <p>{cars && cars.carWarranty}</p>
                              </div>
                            </div>
                            <div className="box">
                              <div className="information-text">
                                {cars && cars.serviceHistory ? (
                                  <>
                                    <img src={serviceicon} alt="" />
                                    Service History
                                  </>
                                ) : null}
                              </div>
                            </div>
                            <div className="box">
                              <div className="information-text">
                                {cars && cars.preInspection ? (
                                  <>
                                    <img src={searchicon} alt="" />
                                    Pre Inspection
                                  </>
                                ) : null}
                              </div>
                            </div>
                            <div className="box">
                              <div className="information-text">
                                {cars && cars.hpiChecked ? (
                                  <>
                                    <img src={checkedicon} alt="Checked Icon" />
                                    HPI Checked
                                  </>
                                ) : null}
                              </div>
                            </div>
                          </div>
                          <div className="addi-information"></div>
                          <div className="addi-information"></div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item
                      eventKey="2"
                      className="car-listing-left-accordion"
                    >
                      <Accordion.Header>SPECIFICATION</Accordion.Header>
                      <Accordion.Body>
                        <div className="car-listing-left">
                          <h5>£{cars && cars.mileage}</h5>
                          <div className="details-box">
                            <div className="inner-title-text">
                              <h3>BODY</h3>
                              <p>
                                {cars && cars.model && cars.model.toUpperCase()}
                              </p>
                            </div>
                            <div className="inner-title-text">
                              <h3>MILEAGE</h3>
                              <p>{cars && cars.mileage} MILES</p>
                            </div>
                            <div className="inner-title-text">
                              <h3>FUEL TYPE</h3>
                              <p>
                                {cars &&
                                  cars.model &&
                                  cars.fuelType.toUpperCase()}
                              </p>
                            </div>
                            <div className="inner-title-text">
                              <h3>ENGINE</h3>
                              <p>{cars && cars.engine}</p>
                            </div>
                            <div className="inner-title-text">
                              <h3>TRANSMISSION</h3>
                              <p>{cars && cars.transmission.toUpperCase()}</p>
                            </div>
                            <div className="inner-title-text">
                              <h3>EXTERIOR COLOUR</h3>
                              <p>
                                {cars &&
                                  cars.model &&
                                  cars.exteriorColor.toUpperCase()}
                              </p>
                            </div>
                            <div className="inner-title-text">
                              <h3>INTERIOR COLOUR</h3>
                              <p>
                                {cars &&
                                  cars.model &&
                                  cars.interiorColor.toUpperCase()}
                              </p>
                            </div>
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>

                  <div className="group-btn d-none d-md-block "></div>
                </div>
              </div>
              <div className="car-list-btn second">
                <button
                  className={`primary-btn sm ${activeButtonIndex === 0 ? "active" : ""
                    }`}
                  onClick={() => {
                    setActiveButtonIndex(0);
                    handleModal2Open();
                  }}
                >
                  <div className="car_icon" />
                  <span>VEHICLE ENQUIRY</span>
                </button>
                <button
                  className={`primary-btn sm ${activeButtonIndex === 1 ? "active" : ""
                    }`}
                  onClick={() => {
                    setActiveButtonIndex(1);
                    // handleModal2Open();
                  }}
                >
                  <img src={partExchnage} alt="" />
                  <span>PART EXCHANGE</span>
                </button>

                <button
                  className={`primary-btn sm ${activeButtonIndex === 2 ? "active" : ""
                    }`}
                  onClick={() => {
                    setActiveButtonIndex(2);
                    handleShare();
                  }}
                >
                  <img src={shareicon} alt="" />
                  <Link style={{ textDecoration: "none" }}>
                    <span> SHARE THIS</span>
                  </Link>
                  {/* SHARE THIS */}
                </button>
                <div className="print">
                  <button
                    className={`primary-btn sm ${activeButtonIndex === 3 ? "active" : ""
                      }`}
                    onClick={() => {
                      setActiveButtonIndex(3);
                      handlePrint();
                    }}
                  >
                    <img src={Printicon} alt="" />
                    <span>Print</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Print;
